/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExhibitionWithRelations } from '../../models/exhibition-with-relations';

export interface EditorGetExhibition$Params {
  id: string;
}

export function editorGetExhibition(http: HttpClient, rootUrl: string, params: EditorGetExhibition$Params, context?: HttpContext): Observable<StrictHttpResponse<ExhibitionWithRelations>> {
  const rb = new RequestBuilder(rootUrl, editorGetExhibition.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExhibitionWithRelations>;
    })
  );
}

editorGetExhibition.PATH = '/editor/exhibitions/{id}';
